export default __webpack_public_path__ + "static/media/manifesto.22dd04e6.md";